<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToInheemsStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/inheems/Asset 1.png" alt="">
    <img draggable="false" id="game_drawer" src="./../../assets/images/inheems/Asset 5.png">

    <span id="inheems_game_text_header">Hoe speel je dit?</span>
    <span id="inheems_game_text">Sleep de juiste benaming naar de juiste object.</span>

    <img draggable="false" @click="goToInheemsGame()" class="clickable" id="inheems_gamestart_btn" src="./../../assets/images/Asset 57.png" alt="">
  </span>
</template>

<script>


export default {
  name: "InheemsMenu",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToInheemsStart() {
      this.$router.push('/inheems/start');
    },
    goToInheemsGame() {
      this.$router.push('/inheems/game');
    },
  },

  computed: {}
};
</script>

<style>
  #inheems_game_text_header {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 18%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 6vw;
    text-align: center;
  }
  #inheems_game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 26%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 2.5vw;
    text-align: center;
  }
  #game_drawer {
    position: absolute;
    margin-top: -0.5%;
    left: 15%;
    width: 70%;
  }
  .tembe_card {
    position: absolute;
    width: 25%;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #tembe_card_1 {
    margin-top: 10%;
    left: 25%;
  }
  #inheems_gamestart_btn {
    position: absolute;
    margin-top: 37%;
    left: 40%;
    width: 20%;
  }
</style>


